export default {
    apiBaseURL: 'https://bc-api.ccachina.net/',
    // apiBaseURL: 'http://api.jianqiu.net/',
    // apiBaseURL: 'https://jianqiu-api.dierqudao.com/',
    // apiBaseURL: 'http://cca.net:8888',
    // apiBaseURL: 'https://cca-api.dierqudao.com/',
    // apiBaseURL: 'http://192.168.1.99', 
    // wsBaseURL: 'ws://cca.net:2346',
    wsBaseURL: 'wss://api-test.cca.dierqudao.com/wss',
    pcBaseURL: 'https://jianqiu-www.ccachina.net',
}